<template>
  <div class="row">
    <div class="col-12">
      <page-header :title="header" />
      <div class="row poppins">
        <div class="col-12">
          <div class="main-row">
            <div
              v-for="d in details"
              :key="d.header"
            >
              <BlockHeader
                v-if="d.header"
                :name="d.header"
              />
              <div class="row">
                <div
                  v-for="i in d.content"
                  :key="i.value"
                  class=" col-lg-6 col-sm-12 col-xs-12"
                >
                  <div class="details-header">
                    {{ i.name | i18n }}
                  </div>
                  <div class="details-value">
                    {{ info[i.value] ? (i.renderRow ? i.renderRow(info) : i.render ? i.render(info[i.value]) : info[i.value]) : '-' }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '../common/page-header';
import BlockHeader from '../common/block-header';

export default {
  title: 'Details instance',
  components: { PageHeader, BlockHeader },
  data: function() {
    return {
      header: '',
      details: [],
      info: {}
    };
  },
  created() {
    this.header = this.$route.params.header;
    this.details = this.$route.params.details;
    this.info = this.$route.params.data;
  }
};
</script>

<style lang="scss" scoped>
::v-deep  #add-customer .modal-dialog {
  max-width: 700px !important;
}

::v-deep  .button-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

::v-deep  .details-header {
  color: #5f5f5f !important;
  font-size: 1.3rem !important;
  font-weight: 400;
  margin-top: 5px;
}

::v-deep  .details-value {
}
::v-deep  .main-row {
  overflow: hidden;
}
</style>
